export type FieldsLabelsConfig<T> = {
  [fieldId in keyof T]: string;
};

export interface FieldsLabels<T> {
  getLabel: (fieldId: keyof T) => string;
  insertLabel: (text: string, fieldId: keyof T) => string;
}

export function fieldsLabels<T>(map: FieldsLabelsConfig<T>): FieldsLabels<T> {
  const getLabel = (fieldId: keyof T): string => map[fieldId] || (fieldId || '').toString();

  return {
    getLabel,
    insertLabel: (text: string, fieldId: keyof T) =>
      text.replace(new RegExp(`\\b${(fieldId || '').toString()}\\b`, 'g'), getLabel(fieldId)),
  };
}
